// extracted by css-extract-rspack-plugin
export default {"bg":"modal-root__bg___hxifc","topMost":"modal-root__topMost___ONDIA","container":"modal-root__container___FGY3m common__shadow-modal___HWvkY"};